"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFilteredScenesForUpdate = getFilteredScenesForUpdate;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _underscore = require("underscore");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @description This passes every scene and returns an updated scenes array
 * trimmed enough with the valid structure for an api update call.
 * @param {Object} scenes
 * @returns Array
 */
function getFilteredScenesForUpdate(scenes) {
  return scenes.map(function (scene) {
    // remove duplicate source layers
    return (0, _underscore.pick)(_objectSpread(_objectSpread({}, scene), {}, {
      layers: scene.layers.map(function (l) {
        return _objectSpread(_objectSpread({}, l), {}, {
          source: (0, _underscore.pick)(l.source, ['_id', 'title', 'type', 'value', 'hidden', 'order', 'thumbnail', 'description'])
        });
      })
    }), ['_id', 'description', 'title', 'layers', 'style', 'thumbnail', 'layout']);
  });
}